export function isIE11() {
    return window != null
        && window.MSInputMethodContext != null
        && document.documentMode != null;
}
//# sourceMappingURL=index.js.map